exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dmb-web__FhaErrorModal__errorModal__ug1ex {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n      -ms-flex-flow: column;\n          flex-flow: column;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.dmb-web__FhaErrorModal__errorTitle__vrkEo {\n  font-size: 20px;\n  padding: 15px 0;\n}\n\n.dmb-web__FhaErrorModal__errorMessage__EEfjT {\n  padding: 15px 0;\n}\n\n.dmb-web__FhaErrorModal__errorButton__o-61I {\n  -ms-flex-item-align: end;\n      align-self: flex-end;\n}", ""]);

// exports
exports.locals = {
	"errorModal": "dmb-web__FhaErrorModal__errorModal__ug1ex",
	"errorTitle": "dmb-web__FhaErrorModal__errorTitle__vrkEo",
	"errorMessage": "dmb-web__FhaErrorModal__errorMessage__EEfjT",
	"errorButton": "dmb-web__FhaErrorModal__errorButton__o-61I"
};